<script>
import BaseModal from '@/components/_common/modal/BaseModal.vue'
import SystemRequirements from "@/components/_common/SystemRequirements.vue";
import lottie from 'lottie-web'
export default {
  name: "PlatformStatement",
  components: { SystemRequirements, BaseModal },
  data () {
    return {
      showRequirementsModal: false
    }
  },
  computed: {
    isDesktop () {
      return this.$mq === 'desktop'
    }
  },
  methods: {
    playLottieAnimation () {

    }
  },
  mounted () {
    const target = document.querySelector('.lottie-container')
    lottie.loadAnimation({
      container: target, // the dom element that will contain the animation
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: '/animation/TherapyArc.json' // the path to the animation json
    })
  }
}
</script>

<template>
  <section class="platform-statement">
    <div class="platform-grid">
      <article class="article-body">
        <header>
          <h2 class="h2-promo mb-2 has-text-white text-outline-dark">One Platform Across the Full Therapy Arc</h2>
        </header>
        <p class="is-size-5 text-semibold">
          OVB supports vision therapy from early skill development through functional carryover and long-term visual efficiency without disrupting continuity or requiring a platform switch.
        </p>
        <button
            v-if="isDesktop"
            class="button is-outlined mt-4"
            @click="showRequirementsModal = !showRequirementsModal"
        >
      <span class="icon is-medium mr-1">
        <i class="mdi mdi-information"></i>
      </span>
          View System Requirements
        </button>
      </article>
      <div
      :class="{'py-6': !isDesktop}">
        <div
            aria-hidden="true"
            class="lottie-container"
        />
      </div>

      <button
          v-if="$mq === 'mobile'"
          class="button is-outlined mt-4"
          @click="showRequirementsModal = !showRequirementsModal"
      >
      <span class="icon is-medium mr-1">
        <i class="mdi mdi-information"></i>
      </span>
        View System Requirements
      </button>
    </div>

    <base-modal
        :show="showRequirementsModal"
        @CLOSE_MODAL="showRequirementsModal = false"
        :has-close-button="true"
        :close-on-mask-click="true"
        :full-screen="false"
        :has-footer="false"
    >
      <template #header>
        System Requirements
      </template>
      <template #content>
        <system-requirements />
      </template>
    </base-modal>
  </section>
</template>

<style scoped lang="scss">
.platform-statement {
  margin: 0 0 4rem 0;
  @include desktop {
    margin: 0 0 20rem 0;
  }

  display: flex;
  align-items: center;
  .platform-grid {
    display: grid;
    grid-template-columns: 1fr;
    grid-column-gap: 2rem;
    @include desktop {
      grid-template-columns: 1fr 2fr;
    }
  }
}
</style>
